module.exports = __webpack_public_path__ + "static/media/loader-big-flash.2b9abd06.svg";